/* Prime Paddle Club fit finder: self-contained, no tracking or network requests. */
(() => {
  if (window.__ppcFitFinderLoaded) return;
  window.__ppcFitFinderLoaded = true;
  const data=[["XS",16,27],["S",18,28],["M",20,29],["L",22,30],["XL",24,31],["2XL",26,32],["3XL",28,33]];
  const sizes=data.map(x=>x[0]);
  function init(root){
    if(root.dataset.fitReady) return;
    root.dataset.fitReady="1";
    const one=s=>root.querySelector(s);
    const panels=root.querySelectorAll("[data-fit-panel]");
    root.querySelectorAll("[data-fit-tab]").forEach(button=>button.addEventListener("click",()=>{
      const name=button.dataset.fitTab;
      root.querySelectorAll("[data-fit-tab]").forEach(tab=>{const active=tab===button;tab.classList.toggle("is-active",active);tab.setAttribute("aria-selected",String(active));});
      panels.forEach(panel=>{panel.hidden=panel.dataset.fitPanel!==name;});
    }));
    const show=(target,heading,detail)=>{target.replaceChildren();const strong=document.createElement("strong");strong.textContent=heading;const p=document.createElement("div");p.textContent=detail;target.append(strong,p);target.hidden=false;};
    one("[data-fit-submit]").addEventListener("click",()=>{
      const feet=Number(one("[data-fit-feet]").value),inch=Number(one("[data-fit-inches]").value),pounds=Number(one("[data-fit-weight]").value);
      const target=one("[data-fit-result]");
      if(feet<4||feet>7||inch<0||inch>11||!Number.isFinite(pounds)||pounds<65||pounds>600){show(target,"Check your measurements","Enter a height from 4–7 feet and a weight from 65–600 lb.");return;}
      const fit=one('input[type="radio"]:checked')?.value||"relaxed";
      const usual=one("[data-fit-usual]").value;
      let index,method;
      if(usual){index=sizes.indexOf(usual);method="Based primarily on your usual unisex T-shirt size and preferred fit.";}
      else{
        // Broad heuristic only; not a manufacturer sizing standard or body measurement.
        const height=feet*12+inch;
        const bmi=703*pounds/(height*height);
        const weightBand=pounds<125?0:pounds<150?1:pounds<185?2:pounds<220?3:pounds<260?4:pounds<310?5:6;
        const frameOffset=bmi>=33?1:bmi<19?-1:0;
        index=weightBand+frameOffset;
        method="Rough starting point based on height and weight; body shape and garment measurements may change your fit.";
      }
      index=Math.max(0,Math.min(sizes.length-1,index+(fit==="closer"?-1:fit==="oversized"?1:0)));
      show(target,"Suggested starting size: "+sizes[index],method+" For the most reliable choice, use Compare measurements.");
    });
    one("[data-fit-compare]").addEventListener("click",()=>{
      const w=Number(one("[data-fit-chest]").value),l=Number(one("[data-fit-length]").value),target=one("[data-fit-compare-result]");
      if(!w||!l||w<10||w>50||l<15||l>45){show(target,"Check your measurements","Enter a flat chest width (10–50 in) and body length (15–45 in).");return;}
      const match=data.reduce((best,x)=>Math.abs(x[1]-w)*2+Math.abs(x[2]-l)<Math.abs(best[1]-w)*2+Math.abs(best[2]-l)?x:best,data[0]);
      show(target,"Closest garment size: "+match[0],"Nominal flat measurements: "+match[1]+" in chest width × "+match[2]+" in length. Actual production tolerances apply.");
    });
  }
  function scan(base=document){if(base.matches?.("[data-ppc-fit]"))init(base);base.querySelectorAll?.("[data-ppc-fit]").forEach(init);}
  scan();
  document.addEventListener("shopify:section:load",e=>scan(e.target));
  const observer=new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)scan(node);})));
  observer.observe(document.documentElement,{subtree:true,childList:true});
})();